import script from "./DividerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DividerComponent.vue?vue&type=script&setup=true&lang=js"

import "./DividerComponent.vue?vue&type=style&index=0&id=4c032018&lang=css"

const __exports__ = script;

export default __exports__